import { useOnline } from '@vueuse/core'
import { computed, ref, watch } from 'vue'

import { isTauri } from '@/services/platformService'
import { settingsService } from '@/services/settingsService'
import { UI_SETTING_KEYS } from '@/services/uiSettingsRegistry'

const forceOfflineSupported = isTauri()

const deviceOnline = useOnline()
const userForcedOfflineMode = ref<boolean>(
  forceOfflineSupported
    ? (settingsService.getSetting<boolean>(UI_SETTING_KEYS.connectivityForceOfflineMode) ?? false)
    : false,
)
const autoOfflineMode = ref<boolean>(!deviceOnline.value)

const forceOfflineMode = computed(() => userForcedOfflineMode.value || autoOfflineMode.value)

const isEffectivelyOnline = computed(() => deviceOnline.value && !forceOfflineMode.value)

watch(
  deviceOnline,
  (online) => {
    autoOfflineMode.value = !online
  },
  { immediate: true },
)

function setForceOfflineMode(enabled: boolean): void {
  if (!forceOfflineSupported) {
    userForcedOfflineMode.value = false
    autoOfflineMode.value = !deviceOnline.value
    settingsService.removeSetting(UI_SETTING_KEYS.connectivityForceOfflineMode)
    return
  }

  userForcedOfflineMode.value = enabled
  settingsService.saveSetting(UI_SETTING_KEYS.connectivityForceOfflineMode, enabled)
}

export const connectivityService = {
  deviceOnline,
  forceOfflineSupported,
  userForcedOfflineMode,
  autoOfflineMode,
  forceOfflineMode,
  isEffectivelyOnline,
  setForceOfflineMode,
}
